import * as React from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { useEffect, useState } from "react";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings.module.scss";
import { process } from "@progress/kendo-data-query";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { getAuthorizations, updateAuthoriations } from "api";
import { SignatureCell } from "../GridComponents";
import { handleApiError } from "Helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import SubmitButton from "components/common/SubmitButton";
import { GridLoader } from "components/GridLoader";

const NumericCell = (props) => {
  return (
    <td className="right-align-full numeric-input-padding">
      {true ? (
        <NumericTextBox
          format={"n2"}
          className="mt-auto"
          min={0}
          value={props.dataItem[props.field]}
          onChange={(e) => {
            if (props.onChange) {
              props.onChange({
                dataIndex: 0,
                dataItem: props.dataItem,
                field: props.field,
                syntheticEvent: e.syntheticEvent,
                value: e.value,
                counter: props.dataItem.counter,
              });
            }
          }}
          spinners={false}
        />
      ) : (
        ""
      )}
    </td>
  );
};

const initialDataState = {
  sort: [{ field: "postingType", dir: "asc" }],
};
const AuthorizationsGrid = () => {
  const [dataState, setDataState] = useState(initialDataState);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [gridLoading, setGridLoading] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const dataStateChange = (e) => {
    if (
      e.dataState.sort !== undefined &&
      e.dataState.skip !== 0 &&
      dataState.sort !== e.dataState.sort
    ) {
      setDataState({ ...e.dataState, skip: 0 });
    } else if (e.dataState.sort[0] === undefined) {
      setDataState({
        ...e.dataState,
        sort: [
          {
            field: dataState.sort[0].field,
            dir: "asc",
          },
        ],
      });
    } else {
      setDataState(e.dataState);
    }
  };

  const AmountNameHeader = (props) => {
    return (
      <div
        onClick={(e) => {
          props.onClick(e);
        }}
        style={{ textAlign: "center", cursor: "pointer" }}
      >
        {props.title}
        {props.children}
      </div>
    );
  };

  const handleSubmit = async () => {
    setIsSaving(true);
    try {
      await updateAuthoriations(data);
      toast.success("Updated Authorisations");
    } catch (error) {
      handleApiError(error);
      toast.error("Unexpected Error Occurred");
    } finally {
      setIsSaving(false);
    }
  };

  const fetchData = async () => {
    try {
      setGridLoading(true);
      const data = await getAuthorizations();
      setData(
        data.data?.data.map((item) => ({
          ...item,
          inEdit: true,
          symbol: item.postingType,
        }))
      );
    } catch (error) {
    } finally {
      setGridLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const itemChange = (e) => {
    let newData = data.map((item) => {
      if (item.postingType === e.dataItem?.postingType) {
        item[e.field || ""] = e.value;
      }
      return item;
    });
    setData(newData);
  };

  return (
    <div className="d-flex flex-column h-100">
      <div className="flex-grow-1 overflow-hidden settings-grid users-grid settings-grid-wrapper" style={{ minHeight: 0, maxWidth: "1400px" }}>
        <Grid
          data={process(data, dataState)}
          showLoader={gridLoading || isSaving}
          loader={
            <div style={{ height: "50px" }}>
              <GridLoader />
            </div>
          }
          dataItemKey={"postingType"}
          onItemChange={itemChange}
          onDataStateChange={dataStateChange}
          {...dataState}
          sortable
          editField="inEdit"
          style={{ height: "100%" }}
          className=""
        >
          <GridNoRecords>
            {gridLoading ? (
              <span></span>
            ) : (
              data && data?.length === 0 && "No records available"
            )}
          </GridNoRecords>
          <Column title=" " field="symbol" cell={SignatureCell} width="60" />
          <Column
            field="name"
            title="Posting Type"
            className="gridBoldField"
            editable={false}
            width="150px"
          />
          <Column
            field="allowChitRequest"
            title="Allows Chit"
            editor="boolean"
            className="text-center"
            width="80px"
          />
          <Column
            field="requiresAuthorisation"
            title="Auth Required"
            editor="boolean"
            className="text-center"
            width="80px"
          />
          <Column
            field="level1Amount"
            title="Amount Level 1"
            editor="numeric"
            cell={NumericCell}
            headerCell={AmountNameHeader}
            headerClassName="pb-3"
            width="140px"
          />
          <Column
            field="level2Amount"
            title="Amount Level 2"
            editor="numeric"
            cell={NumericCell}
            headerCell={AmountNameHeader}
            headerClassName="pb-3"
            width="140px"
          />
          <Column
            field="level3Amount"
            title="Amount Level 3"
            editor="numeric"
            cell={NumericCell}
            headerCell={AmountNameHeader}
            headerClassName="pb-3"
            width="140px"
          />
        </Grid>
      </div>
      <div className={`${styles["buttons-container"]} d-flex align-items-center justify-content-end gap-2 px-4 py-3`}>
        <Button
          className="common-btn bgBtnSecondary"
          onClick={() => navigate("/settings")}
        >
          Cancel
        </Button>
        <SubmitButton
          onClick={handleSubmit}
          isLoading={isSaving}
          disabled={gridLoading}
        >
          Save
        </SubmitButton>
      </div>
    </div>
  );
};
export default AuthorizationsGrid;
